import { AxiosResponse } from 'axios';

import { client } from '../client';
import { ValidateMLIPincodeResponse } from '../types';

import { termEndPoints } from './endpoints';

export const termProposalAPIs = {
  // get proposal
  getProposal<t = any>(policyId: string) {
    return client.get<t>(termEndPoints.proposal(policyId));
  },

  // save proposal
  saveProposal(policyId: string, proposalForm: any) {
    return client.post(termEndPoints.proposal(policyId), {
      policyID: policyId,
      proposal_form: proposalForm
    });
  },

  // submit proposal
  async submitProposal(policyId: string, paperless: boolean) {
    return client.post(termEndPoints.submitProposal(policyId), {
      only_soft_copy: paperless
    });
  },

  getHDFCLifePincodeData: (pincode: string): Promise<AxiosResponse<any>> => {
    return client.get(termEndPoints.hdfcLifePincodeData(pincode));
  },
  validateMLIPincode: async (
    pincode: string
  ): Promise<ValidateMLIPincodeResponse> => {
    return client.get(termEndPoints.validateMLIPincode(pincode));
  }
};
